function parseInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}
  
function refreshCart(updatedSections) {
  if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
    BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
  }
  
  let cartSelector = document.getElementById('main-cart-items').dataset.id;
  document.getElementById("shopify-section-" + cartSelector).innerHTML = parseInnerHTML(updatedSections[cartSelector], "#shopify-section-" + cartSelector);

  document.getElementById('cart-icon-bubble').innerHTML = parseInnerHTML(updatedSections["cart-icon-bubble"], "#shopify-section-cart-icon-bubble");
  document.getElementById('cart-live-region-text').innerHTML = parseInnerHTML(updatedSections["cart-live-region-text"], "#shopify-section-cart-live-region-text");

  let footerSelector = document.getElementById('main-cart-footer').dataset.id;
  document.getElementById("shopify-section-" + footerSelector).innerHTML = parseInnerHTML(updatedSections[footerSelector], "#shopify-section-" + footerSelector);
}

function addGiftToCart(variantID) {
  console.log(variantID);
  let sectionSelectors = document.getElementById('main-cart-items').dataset.id + ",cart-icon-bubble,cart-live-region-text," + document.getElementById('main-cart-footer').dataset.id;
  console.log(variantID);
  let formData = {
   'items': [{
    'id': variantID,
    'quantity': 1
    }],
    'sections': sectionSelectors
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((response) => response.json())
  .then((data) => {
    refreshCart(data.sections);
    if ((variantID == 43944155807939) ||  (variantID == 43944155447491) || (variantID == 43944154792131) || (variantID == 43948590661827) || (variantID == 44878989852867) || (variantID == 44880255353027) || (variantID == 54085813862595)) {
      clearNoshiItems(variantID);
    }
    return data;
  })
}

function removeGiftFromCart(variantID) {
  
  let sectionSelectors = document.getElementById('main-cart-items').dataset.id + ",cart-icon-bubble,cart-live-region-text," + document.getElementById('main-cart-footer').dataset.id;
  
  let formData = {
    'id': variantID,
    'quantity': 0,
    'sections': sectionSelectors
  };

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then((response) => response.json())
  .then((data) => {
    refreshCart(data.sections);
    return data;
  })
}

function checkboxItemUpdate(event) {
  if (this.checked) {
    addGiftToCart(event.target.value);
  } else {
    removeGiftFromCart(event.target.value);
  }
}

function giftingSectionUpdate(event){
  let assemblageId = "gifting-section-" + this.dataset.assemblage;
  let giftingSectionSelector = document.getElementById(assemblageId);
  if (this.checked) {
    giftingSectionSelector.classList.add('gifting-section-active');
    giftingSectionSelector.classList.remove('gifting-section-inactive');
  } else {
    giftingSectionSelector.classList.remove('gifting-section-active');
    giftingSectionSelector.classList.add('gifting-section-inactive');
    collapseCheckboxItems(this.dataset.assemblage);
  }
}

function giftingEventHandlers() {
  let giftingSection = document.querySelectorAll(".gifting-section-trigger");
  giftingSection.forEach(section => {
    section.addEventListener('change', giftingSectionUpdate);
  });
  
  let giftingCheckboxes = document.querySelectorAll(".gifting-checkbox");
  giftingCheckboxes.forEach(box => {
    box.addEventListener('change', checkboxItemUpdate);
  });

  let quantityDropdowns = document.querySelectorAll('.gift-item-quantity-dropdown');
  quantityDropdowns.forEach(dropdown => {
    dropdown.addEventListener('change', updateGiftboxQuantity);
  });

  let attributeTextboxes = document.querySelectorAll('.noshi-input');
  attributeTextboxes.forEach(textbox => {
    textbox.addEventListener('blur', postCartAttribute);
  });

  let assemblageDropdowns = document.querySelectorAll('.assemblage-quantity-dropdown');
  assemblageDropdowns.forEach(aDropdown => {
    aDropdown.addEventListener('change', assemblageChangeQuantity);
  });
}

function clearCartItems(updates) {

  let sectionSelectors = document.getElementById('main-cart-items').dataset.id + ",cart-icon-bubble,cart-live-region-text," + document.getElementById('main-cart-footer').dataset.id;
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: updates,
      sections: sectionSelectors
    })
  })
  .then((response) => response.json())
  .then((data) => {
    refreshCart(data.sections);
    return data;
  })
}

function collapseCheckboxItems(assemblage) {
  if (assemblage == "reserves") {
    let updates = {};
    updates[44880255353027] = 0;
    updates[44880255385795] = 0;
    
    clearCartItems(updates);
  }
  
  if (assemblage == "assemblage6") {
    let updates = {};
    updates[44878990115011] = 0;
    updates[44878989852867] = 0;
    updates[44878989263043] = 0;
    
    clearCartItems(updates);
  }

  if (assemblage == "assemblage5") {
    let updates = {};
    updates[43944153710787] = 0;
    updates[43944155807939] = 0;
    updates[43944161673411] = 0;
    
    clearCartItems(updates);
  }

  if (assemblage == "assemblage4") {
    let updates = {};
    updates[43944152891587] = 0;
    updates[43944155447491] = 0;
    updates[43944161640643] = 0;
    
    clearCartItems(updates);
  }

  if (assemblage == "assemblage3") {
    let updates = {};
    updates[43944154071235] = 0;
    updates[43944154792131] = 0;
    updates[43944161411267] = 0;
    
    clearCartItems(updates);
  }  

  if (assemblage == "assemblage2") {
    let updates = {};
    updates[43948590530755] = 0;
    updates[43948590661827] = 0;
    updates[43948590366915] = 0;
    
    clearCartItems(updates);
  }  
}

function updateGiftboxQuantity(event){

  let sectionSelectors = document.getElementById('main-cart-items').dataset.id + ",cart-icon-bubble,cart-live-region-text," + document.getElementById('main-cart-footer').dataset.id;
  
  // Get the selected quantity
  const newQuantity = event.target.value;
  
  // Get the line item ID from the data attribute
  const variantId = event.target.getAttribute('data-variant-id');
  
  // Send a POST request to update the quantity for this line item
  fetch('/cart/change.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
      },
      body: JSON.stringify({
          id: variantId,    // Line item ID
          quantity: newQuantity,  // New quantity
          sections: sectionSelectors
      })
  })
  .then(response => response.json())
  .then(data => {
      refreshCart(data.sections);
      return data;
  })
  .catch(error => {
      console.error("Error updating cart:", error);
  });
}


function clearNoshiItems(variantID) {
  //Reserves
  if (variantID == 44880255353027) {
    let updates = {};
    updates[43944155447491] = 0;
    updates[43944154792131] = 0;
    updates[43948590661827] = 0;
    updates[43944155807939] = 0;
    updates[44878989852867] = 0;

    
    updates[54085813862595] = 0;

    clearCartItems(updates);
  }

  //A6 Noshi
  if (variantID == 44878989852867) {
    let updates = {};
    updates[43944155447491] = 0;
    updates[43944154792131] = 0;
    updates[43948590661827] = 0;
    updates[43944155807939] = 0;
    updates[44880255353027] = 0;
    
    updates[54085813862595] = 0;

    clearCartItems(updates);
  }

  //A5 Noshi
  if (variantID == 43944155807939) {
    let updates = {};
    updates[43944155447491] = 0;
    updates[43944154792131] = 0;
    updates[43948590661827] = 0;
    updates[44878989852867] = 0;
    updates[44880255353027] = 0;
    
    updates[54085813862595] = 0;

    clearCartItems(updates);
  }

  //A4 Noshi
  if (variantID == 43944155447491) {
    let updates = {};
    updates[43944155807939] = 0;
    updates[43944154792131] = 0;
    updates[43948590661827] = 0;
    updates[44878989852867] = 0;
    updates[44880255353027] = 0;
    
    updates[54085813862595] = 0;

    clearCartItems(updates);
  }

  //A3 Noshi
  if (variantID == 43944154792131) {
    let updates = {};
    updates[43944155807939] = 0;
    updates[43944155447491] = 0;
    updates[43948590661827] = 0;
    updates[44878989852867] = 0;
    updates[44880255353027] = 0;
    
    updates[54085813862595] = 0;

    clearCartItems(updates);
  }  

  //A2 Noshi
  if (variantID == 43948590661827) {
    let updates = {};
    updates[43944155807939] = 0;
    updates[43944155447491] = 0;
    updates[43944154792131] = 0;
    updates[44878989852867] = 0;
    updates[44880255353027] = 0;
    
    updates[54085813862595] = 0;

    clearCartItems(updates);
  }  

  //A7 Noshi
  if (variantID == 54085813862595) {
    let updates = {};
    updates[43944155807939] = 0;
    updates[43944155447491] = 0;
    updates[43944154792131] = 0;
    updates[43948590661827] = 0;
    updates[44878989852867] = 0;
    updates[44880255353027] = 0;

    clearCartItems(updates);
  }

}

function updateCartAttributes(attributes) {
  fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Cart updated:', cart);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
  });
}

function postCartAttribute(event){
  const attributeValue = this.value;
  
  if ((attributeValue.trim() !== '') && (attributeValue !== this.dataset.initial)) {
    let attributes = {}
    attributes[String(this.name)] = attributeValue;
    updateCartAttributes(attributes);
  }
  
}

function clearCheckboxItemsAndAssemblage(assemblageHandle, assemblageId ) {
  if (assemblageHandle == "assemblage7") {
    let currentID = assemblageId;
    let updates = {};
    updates[54085813797059] = 0;
    updates[54085813862595] = 0;
    updates[54085814517955] = 0;
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }

  if (assemblageHandle == "reserves") {
    let currentID = assemblageId;
    let updates = {};
    updates[44880255353027] = 0;
    updates[44880255385795] = 0;
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }

  if (assemblageHandle == "assemblage6") {
    let currentID = assemblageId;
    let updates = {};
    updates[44878990115011] = 0;
    updates[44878989852867] = 0;
    updates[44878989263043] = 0;
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }
  
  if (assemblageHandle == "assemblage5") {
    let currentID = assemblageId;
    let updates = {};
    updates[43944153710787] = 0;
    updates[43944155807939] = 0;
    updates[43944161673411] = 0;
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }
  
  if (assemblageHandle == "assemblage4") {
    let currentID = assemblageId;
    let updates = {};
    updates[43944152891587] = 0;
    updates[43944155447491] = 0;
    updates[43944161640643] = 0;
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }

  if (assemblageHandle == "assemblage3") {
    let currentID = assemblageId;
    let updates = {};
    updates[43944154071235] = 0;
    updates[43944154792131] = 0;
    updates[43944161411267] = 0;
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }

  if (assemblageHandle == "assemblage2") {
    let currentID = assemblageId;
    let updates = {};
    updates[43948590530755] = 0;
    updates[43948590661827] = 0;
    updates[43948590366915] = 0;
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }

  if (assemblageHandle == "a2-isshoubin") {
    let currentID = assemblageId;
    let updates = {};
    updates[currentID] = 0;
    
    clearCartItems(updates);
  }
}


function assemblageChangeQuantity(event) {
  console.log("Change!");
  const newQuantity = event.target.value;
  
  // Get the line item ID from the data attribute
  const variantId = event.target.getAttribute('data-assemblage-id');
  const assemblageHandle = event.target.getAttribute('data-assemblage-handle');
  console.log(newQuantity);
  console.log(assemblageHandle);

  if (newQuantity == 0) {
    console.log("Back to 0!");
    clearCheckboxItemsAndAssemblage(assemblageHandle, variantId);
  } else {
    console.log("Update!");
    let sectionSelectors = document.getElementById('main-cart-items').dataset.id + ",cart-icon-bubble,cart-live-region-text," + document.getElementById('main-cart-footer').dataset.id;
    // Send a POST request to update the quantity for this line item
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,    // Line item ID
            quantity: newQuantity,  // New quantity
            sections: sectionSelectors
        })
    })
    .then(response => response.json())
    .then(data => {
        refreshCart(data.sections);
        return data;
    })
    .catch(error => {
        console.error("Error updating cart:", error);
    });
  }
}
